import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import {
  MatAutocompleteSelectedEvent,
  MatDatepickerInputEvent,
  MatDialog,
  MatSelect
} from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddEditPayoutOrderDialog } from "./add-edit-payout-order/add-edit-payout-order.component";
import { PayoutReportHistoryDialogComponent } from "./payout-report-history-dialog/payout-report-history-dialog.component";
import { PayoutErrorReportDialogComponent } from "./payout-error-report-dialog/payout-error-report-dialog.component";
import { amountFormatter } from "../custompipes/amount-formatter";

@Component({
  selector: "app-payout",
  templateUrl: "./payout-orders.component.html",
  styleUrls: ["./payout-orders.component.css"],
})

export class PayoutOrdersComponent implements OnInit {
  @ViewChild('userSelect') userSelect: MatSelect;

  _csrf: string;
  request_id: string = "";

  // AG Grid properties
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
    cellStyle: { display: 'flex', alignItems: 'center' }
  };

  oPayouts: any = [];
  payouts: any = [];
  searchValue: string = '';
  userList: any[] = [];
  filteredUserList: any[] = [];
  userSearchValue: string = '';
  isUserSelectOpen: boolean = false;
  paymentStatusOptions: string[] = ['ALL', 'FAILED', 'COMPLETED', 'PROCESSING', 'RETRYING', 'APPROVED', 'ERROR', 'PENDING', 'REJECTED'];
  // Gateway codes from Offramp Payout Gateways, active or not (loadGatewayOptions)
  paymentGatewayOptions: string[] = ['ALL'];
  filter: any = {
    page: 1,
    limit: 100,
    fromDate: moment().format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    paymentStatus: 'ALL', // Default value
    paymentGateway: 'ALL', // Default to all gateways
    searchId: '',
    userId: '' // Default to all users
  };
  prev_disabled = true;
  next_disabled = false;
  totalOrders: number = 0;
  totalCryptoAmount: number = 0;
  totalPayoutAmount: number = 0;
  creditPendingCount: number = 0;

  // Date picker filter function (allows all dates)
  myFilter = (d: Date | null): boolean => {
    return true; // Allow all dates
  };

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  loadUserList() {
    if (!this._csrf) {
      console.warn('CSRF token not available, cannot load user list');
      return;
    }

    const filter = {
      _csrf: this._csrf,
      perpage: 10000,
      page: 1,
      search: '',
      status: 'Active'
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        console.log('User list response:', response);
        if (response && response.customers && Array.isArray(response.customers)) {
          this.userList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.userList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.userList = response.data;
        } else if (response && response.status && response.customers) {
          // Handle response with status property
          this.userList = response.customers || [];
        } else {
          this.userList = [];
          console.warn('Unexpected response format:', response);
        }
        this.filteredUserList = this.userList;
        console.log('Loaded user list:', this.userList.length, 'users');
      },
      (error) => {
        console.error('Error loading user list:', error);
        this.userList = [];
        this.filteredUserList = [];
      }
    );
  }

  loadGatewayOptions() {
    this.offrampService.getPayoutGatewayLookup().subscribe(
      (response: any) => {
        const codes = ((response && response.data) || []).map((gateway) => gateway.code).filter((code) => !!code);
        this.paymentGatewayOptions = ['ALL', ...codes];
      },
      (error) => {
        console.error('Error loading payout gateways:', error);
      }
    );
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.justifyContent = 'flex-start';
          container.style.height = '100%';
          container.style.width = '100%';
          (container.style as any).gap = '5px';

          // View button
          const viewBtn = document.createElement('button');
          viewBtn.type = 'button';
          viewBtn.className = 'btn btn-sm btn-info';
          viewBtn.title = 'View';
          viewBtn.style.display = 'flex';
          viewBtn.style.alignItems = 'center';
          viewBtn.style.justifyContent = 'center';
          viewBtn.style.padding = '4px 8px';
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, 'Payout Order');
          };
          container.appendChild(viewBtn);

          // Approve button
          if (element.IsActive && (element.OrderStatus == 'PROCESSING' && element.PaymentStatus == 'PENDING')) {
            const approveBtn = document.createElement('button');
            approveBtn.type = 'button';
            approveBtn.className = 'btn btn-sm btn-success';
            approveBtn.title = 'Approve';

            approveBtn.style.display = 'flex';
            approveBtn.style.alignItems = 'center';
            approveBtn.style.justifyContent = 'center';
            approveBtn.style.padding = '4px 8px';
            approveBtn.innerHTML = '<i class="fa fa-check"></i>';
            approveBtn.onclick = (e) => {
              e.stopPropagation();
              this.processPayout('approve', element._id, element.AttemptNo);
            };
            container.appendChild(approveBtn);
          }

          // Status Check button (for PROCESSING)
          if (element.IsActive && (element.PaymentStatus == 'PROCESSING' || element.PaymentStatus == 'FAILED' || element.PaymentStatus == 'ERROR')) {
            const statusBtn = document.createElement('button');
            statusBtn.type = 'button';
            statusBtn.className = 'btn btn-sm btn-info';
            statusBtn.title = 'Check Status';

            // Styling (same as other buttons)
            statusBtn.style.display = 'flex';
            statusBtn.style.alignItems = 'center';
            statusBtn.style.justifyContent = 'center';
            statusBtn.style.padding = '4px 8px';
            statusBtn.style.marginLeft = '5px';

            // Default icon (visible now - FA4 supported)
            statusBtn.innerHTML = '<i class="fa fa-refresh"></i>';

            statusBtn.onclick = (e) => {
              e.stopPropagation();

              // Show loading spinner when clicked
              /*statusBtn.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
              statusBtn.disabled = true;
              statusBtn.style.cursor = 'not-allowed';
              statusBtn.title = 'Checking...';*/

              this.processPayout('status_check', element._id, element.AttemptNo);
            };

            container.appendChild(statusBtn);
          }

          // Reject button
          if (element.IsActive && element.OrderStatus == 'PROCESSING' && (element.PaymentStatus == 'PENDING' || element.PaymentStatus == 'FAILED')) {
            const rejectBtn = document.createElement('button');
            rejectBtn.type = 'button';
            rejectBtn.className = 'btn btn-sm btn-danger';
            rejectBtn.title = 'Reject';
            rejectBtn.style.display = 'flex';
            rejectBtn.style.alignItems = 'center';
            rejectBtn.style.justifyContent = 'center';
            rejectBtn.style.padding = '4px 8px';
            rejectBtn.innerHTML = '<i class="fa fa-times"></i>';
            rejectBtn.onclick = (e) => {
              e.stopPropagation();
              this.processPayout('reject', element._id, element.AttemptNo);
            };
            container.appendChild(rejectBtn);
          }

          // Edit/Update button
          if (element.IsActive) {
            const editBtn = document.createElement('button');
            editBtn.type = 'button';
            editBtn.className = 'btn btn-sm btn-primary';
            editBtn.title = 'Edit';
            editBtn.style.display = 'flex';
            editBtn.style.alignItems = 'center';
            editBtn.style.justifyContent = 'center';
            editBtn.style.padding = '4px 8px';
            editBtn.innerHTML = '<i class="fa fa-edit"></i>';
            editBtn.onclick = (e) => {
              e.stopPropagation();
              this.editRecord(element);
            };
            container.appendChild(editBtn);
          }

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 150,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }
      },
      {
        headerName: 'Name',
        field: 'UserId.name',
        valueGetter: (params) => {
          if (params.data && params.data.UserId && params.data.UserId.name) {
            return params.data.UserId.name;
          }
          return '';
        },
        flex: 1
      },
      {
        headerName: 'PaymentStatus',
        field: 'PaymentStatus',
        flex: 0.9,
        cellRenderer: (params) => this.renderPaymentStatus(params.value),
      },
      { headerName: 'PayoutAmount', field: 'PayoutAmount', flex: 1, valueFormatter: amountFormatter },
      {
        headerName: 'PaymentGateway',
        field: 'PaymentGateway',
        flex: 1.4,
        // Gateway with its MID, e.g. "CENTXORG (347627154573947)"
        valueGetter: (params) => {
          const data = params.data || {};
          return data.PaymentGateway ? (data.MId ? `${data.PaymentGateway} (${data.MId})` : data.PaymentGateway) : '';
        }
      },
      {
        headerName: 'Attempt',
        field: 'AttemptNo',
        flex: 0.9,
        // The copy of an earlier attempt kept when the order was retried
        valueGetter: (params) => {
          const data = params.data || {};
          return data.IsActive === false ? `${data.AttemptNo} · retried` : data.AttemptNo;
        }
      },
      {
        headerName: 'Attempt Sent',
        field: 'AttemptSentAt',
        headerTooltip: 'When this attempt was sent to its gateway',
        valueFormatter: (params) => (params.value ? moment(params.value).format('MMM DD, hh:mm:ss A') : ''),
        flex: 1.3
      },
      {
        headerName: 'Attempt (s)',
        field: 'AttemptSeconds',
        headerTooltip: 'This attempt: sent to its gateway -> last status update received',
        flex: 0.9
      },
      { headerName: 'Note', field: 'Note', flex: 1 },
      {
        headerName: 'Gateway Debit',
        field: 'GatewayDebitStatus',
        flex: 1,
        headerTooltip: 'Gateway wallet debit of this attempt: debited, credited back after a failure, or credit pending',
        cellRenderer: (params) => this.renderLedgerStatus(params.value),
      },
      {
        headerName: 'WalletStatus',
        field: 'UserWalletStatus',
        flex: 1,
        headerTooltip: 'Client wallet (Manage Wallet clients): debited once per order, credited back when the order finally fails',
        cellRenderer: (params) => this.renderLedgerStatus(params.value),
      },
      {
        headerName: 'ReversalStatus',
        field: 'ReversalStatus',
        flex: 1,
        headerTooltip: 'Gateway / bank confirmation that the money came back (FAILED / REJECTED orders)',
        cellStyle: (params) => this.getReversalCellStyle(params.data),
      },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 2
      },
      {
        headerName: 'AccountHolderName',
        field: 'PaymentInstruction.AccountHolderName', // optional, but not strictly needed
        flex: 1.2,
        valueGetter: function (params) {
          return params.data && params.data.PaymentInstruction ? params.data.PaymentInstruction.AccountHolderName : '';
        }
      },
      {
        headerName: 'AccountNumber / UPI',
        field: 'PaymentInstruction.AccountNumber', // optional, but not strictly needed
        flex: 1.2,
        // UPI payouts have the beneficiary's UPI id instead of an account number
        valueGetter: function (params) {
          const instruction = params.data && params.data.PaymentInstruction;
          return instruction ? (instruction.Mode === 'UPI' ? instruction.UpiId : instruction.AccountNumber) : '';
        }
      },
      { headerName: 'ClientOrderId', field: 'ClientOrderId', flex: 1.2 },
      { headerName: 'PaymentOrderId', field: 'PaymentOrderId', flex: 1.2 },
      { headerName: 'PaymentRefId', field: 'PaymentRefId', flex: 1.2 },
      { headerName: 'PaymentTxnId', field: 'PaymentTxnId', flex: 1.2 },
      { headerName: 'OrderStatus', field: 'OrderStatus', flex: 0.8 },
      { headerName: 'Credit BatchId', field: 'CreditBatchIds', flex: 1 },
      { headerName: 'Credit Allocation', field: 'CreditAllocationAmount', flex: 1 },
      { headerName: 'Credit Status', field: 'CreditAllocationStatus', flex: 1 },
      { headerName: 'MId', field: 'MId', flex: 0.8 },
      { headerName: 'IsActive', field: 'IsActive', flex: 0.8 },
      { headerName: 'PayoutType', field: 'PayoutType', flex: 0.8 },
      { headerName: 'TxnStatus', field: 'TxnStatus', flex: 0.8 },
      {
        headerName: 'Rate',
        field: 'Rate',
        valueGetter: (params) => {
          if (params.data) {
            return params.data.Rate || params.data.FixedRate || '--';
          }
          return '--';
        },
        flex: 0.8
      },

      { headerName: 'OrderId', field: '_id', flex: 1.2 },
      { headerName: 'FiatCurrency', field: 'FiatCurrency', flex: 0.8 },
      { headerName: 'FiatAmount', field: 'FiatAmount', flex: 1, valueFormatter: amountFormatter },
      { headerName: 'CryptoCurrency', field: 'CryptoCurrency', flex: 1 },
      { headerName: 'CryptoAmount', field: 'CryptoAmount', flex: 1 },
      { headerName: 'TdsCharged', field: 'TdsCharged', flex: 1 },

      { headerName: 'QuoteId', field: 'QuoteId', flex: 1 },
      { headerName: 'Network', field: 'Network', flex: 0.8 },
      { headerName: 'TxnHash', field: 'TxnHash', flex: 1.5 },
      { headerName: 'TxnId', field: 'TxnId', flex: 1 },


      {
        headerName: 'UpdatedAt',
        field: 'updatedAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 2
      },
      {
        headerName: 'Diff (s)',
        field: 'DiffSeconds',
        flex: 1
      },
      // Sent to a gateway -> last payment status change
      { headerName: 'Gateway (s)', field: 'GatewaySeconds', flex: 1 },
      // Order received -> last payment status change (what the client waited)
      { headerName: 'Total (s)', field: 'TotalSeconds', flex: 1 }
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      // Copy of an earlier attempt (IsActive false): lighter and italic, the active row carries the outcome
      getRowStyle: (params) => (params.data && params.data.IsActive === false ? { color: '#8a8a8a', fontStyle: 'italic', background: '#fafafa' } : null)
    };
  }

  // ReversalStatus (gateway / bank confirmation the money came back) of FAILED / REJECTED orders: green when
  // REVERSED or NOT_REQUIRED, light red while PENDING. Copies of earlier attempts are left plain.
  private getReversalCellStyle(order: any) {
    if (!order || order.IsActive === false || (order.PaymentStatus !== 'FAILED' && order.PaymentStatus !== 'REJECTED')) {
      return null;
    }
    const isReversed = order.ReversalStatus === 'REVERSED' || order.ReversalStatus === 'NOT_REQUIRED';
    return { background: isReversed ? '#e6ffe6' : '#ffe6e6' };
  }

  private chip(text: string, color: string, background: string, title = '') {
    const span = document.createElement('span');
    span.textContent = text;
    span.title = title;
    span.style.cssText = `display:inline-block;padding:1px 8px;border-radius:10px;font-size:11px;font-weight:600;font-style:normal;line-height:18px;color:${color};background:${background};`;
    return span;
  }

  // PaymentStatus as a coloured chip
  private renderPaymentStatus(status: string) {
    const colors = {
      COMPLETED: ['#1b5e20', '#c8e6c9'],
      FAILED: ['#b71c1c', '#ffcdd2'],
      PROCESSING: ['#0d47a1', '#bbdefb'],
      ERROR: ['#e65100', '#ffe0b2'],
      RETRYING: ['#4a148c', '#e1bee7'],
      REJECTED: ['#424242', '#e0e0e0'],
    };
    const [color, background] = colors[status] || ['#424242', '#f0f0f0'];
    return status ? this.chip(status, color, background, status === 'ERROR' ? 'Outcome unknown: check with the gateway' : '') : '';
  }

  // Gateway Debit / WalletStatus from the ledgers: neutral when debited, red while a failed payout's debit is not
  // credited back, green once credited back, orange when something does not add up
  private renderLedgerStatus(status: string) {
    const styles = {
      DEBITED: ['DEBITED', '#424242', '#eeeeee', 'Debited; payout completed or in progress'],
      CREDIT_PENDING: ['CREDIT PENDING', '#b71c1c', '#ffcdd2', 'Payout failed but the debit is not credited back yet'],
      CREDITED_BACK: ['CREDITED BACK', '#1b5e20', '#c8e6c9', 'Payout failed and the debit was credited back'],
      NOT_DEBITED: ['NOT DEBITED', '#9e9e9e', 'transparent', 'Never debited (not sent to a gateway)'],
      CHECK: ['CHECK', '#e65100', '#ffe0b2', 'Ledger does not match: completed but credited back, or amount differs'],
      PER_ORDER: ['—', '#9e9e9e', 'transparent', 'Client wallet is debited once per order: see the active row'],
      NOT_APPLICABLE: ['—', '#9e9e9e', 'transparent', 'Not applicable'],
    };
    const style = styles[status];
    return style ? this.chip(style[0], style[1], style[2], style[3]) : '';
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.loadUserList();
        this.loadGatewayOptions();
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }


  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      console.log(event.value, "event value");
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  goNext() {
    this.filter.page++;
    this.getData();
  }

  goPrev() {
    if (this.filter.page > 1) {
      this.filter.page--;
      this.getData();
    }
  }

  refreshStatus() {
    /*this.filter = {
      page: 1,
      limit: 100,
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      paymentStatus: 'FAILED', // Reset to default
      searchId: '',
      userId: '' // Reset to all users
    };

    // Clear search filter
    this.searchValue = '';
    this.userSearchValue = '';
    this.filteredUserList = this.userList;
    if (this.gridApi) {
      this.gridApi.setQuickFilter('');
    }

    // Reset local payouts
    this.payouts = this.oPayouts;

    // Reload data
    this.getData();*/
    this.processPayout('status_check_all', 'ALL', 0);

  }

  // Search box: any one id (order _id, ClientOrderId, gateway order id / reference, UTR), looked up by the
  // API on any date, so the date range does not have to cover the order
  applyFilter(filterValue) {
    this.searchValue = (filterValue || '').trim();
    this.getSearchData();
  }

  clearSearch() {
    this.applyFilter('');
  }

  onPaymentStatusChange(newStatus: string) {
    //this.filter.paymentStatus = newStatus;
    console.log('Selected payment status:', newStatus);
    //this.filter.page = 1;
    // Note: We do NOT call getData() here to avoid API calls on every filter change
    // The API will be called only when the user clicks the Search button, allowing them to set multiple filters before fetching data
  }

  getSearchData() {
    // When Search button is clicked, we call getData() which will use the current filter settings (including paymentStatus and userId)
    this.filter.page = 1;
    this.getData();
  }

  // Calls API with date filters only (fromDate, toDate). Search is NOT sent to API.
  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    // The API matches the id exactly on any date (see applyFilter)
    this.filter.searchId = this.searchValue || '';
    this.userService.getPayoutOrders(this.filter).subscribe((list: any) => {
      this.payouts = list;
      this.oPayouts = list;
      this.rowData = list;
      // Rows on this page whose failed payout is not credited back yet (gateway or client wallet)
      this.creditPendingCount = (list || []).filter((row) => row.GatewayDebitStatus === 'CREDIT_PENDING' || row.UserWalletStatus === 'CREDIT_PENDING').length;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        // Rows are already filtered by the API: an order found by a field that is not a column (gateway
        // reference) would be hidden by a grid text filter
        this.gridApi.setQuickFilter('');
        this.payouts = this.oPayouts;
      }

      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      } else {
        this.next_disabled = false;
      }
    });

    this.userService.getPayoutOrderCount(this.filter).subscribe((response: any) => {
      this.totalOrders = response && response.totalCount ? response.totalCount : 0;
      this.totalCryptoAmount = response && response.totalCryptoAmount ? response.totalCryptoAmount : 0;
      this.totalPayoutAmount = response && response.totalPayoutAmount ? response.totalPayoutAmount : 0;
    });
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      var search = searchValue.toLowerCase();
      this.payouts = this.oPayouts.filter(function (x) {
        return (
          (x.ClientOrderId && x.ClientOrderId.toLowerCase().includes(search)) ||
          (x._id && x._id.toLowerCase().includes(search)) ||
          (x.UserId && x.UserId.name && x.UserId.name.toLowerCase().includes(search)) ||
          (x.FiatCurrency && x.FiatCurrency.toLowerCase().includes(search)) ||
          (x.CryptoCurrency && x.CryptoCurrency.toLowerCase().includes(search))
        );
      });
    } else {
      this.payouts = this.oPayouts;
    }
  }

  displayProperJson(jsonData, eventType) {
    console.log(jsonData, eventType, "jsonData in payout orders");
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "Payout Order"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }

  processPayout(action: string, id: string, AttemptNo: number) {
    const request_id = id;
    if (!confirm(`Are you sure you want to ${action} this payout?`)) {
      return;
    }
    this.spinnerService.show();
    let payload = {
      request_id,
      action,
      _csrf: this._csrf,
      AttemptNo: AttemptNo
    };
    this.userService.pyaoutOrderApproveReject(payload).subscribe(
      (res) => {
        this.notifSer.success("Success", res.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });

        this.getData();
        this.spinnerService.hide();
      },
      (err) => {
        this.notifSer.error(
          "Error",
          "Something went wrong, please try again later.",
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          }
        );
        this.spinnerService.hide();
      }
    );
  }

  exportArray() {
    this.spinnerService.show();

    // Create export filter with same parameters but without pagination
    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      paymentStatus: this.filter.paymentStatus,
      paymentGateway: this.filter.paymentGateway,
      userId: this.filter.userId || '',
      // Remove pagination to get all data
      page: 1,
      searchId: this.searchValue || '',
      limit: 20000 // Set a very large limit to get all records
    };

    // Fetch all data from API (export endpoint returns createdAt/updatedAt in IST)
    this.userService.exportPayoutOrders(exportFilter).subscribe(
      (list: any) => {
        if (list && list.length > 0) {
          // Transform data for export
          let exportData = list.map(x => {
            const { DiffSeconds, GatewaySeconds, TotalSeconds, AttemptSeconds, ...rest } = x;
            return {
              ...rest,
              UserId: x.UserId ? x.UserId._id : '',
              UserName: x.UserId ? x.UserId.name : '',
              AccountHolderName: x.PaymentInstruction ? x.PaymentInstruction.AccountHolderName : '',
              AccountNumber: x.PaymentInstruction ? x.PaymentInstruction.AccountNumber : '',
              UpiId: x.PaymentInstruction ? x.PaymentInstruction.UpiId || '' : '',
              IFSC: x.PaymentInstruction ? x.PaymentInstruction.IFSC : '',
              PaymentInstruction: x.PaymentInstruction ? JSON.stringify(x.PaymentInstruction) : '',
              PaymentResponse: x.PaymentResponse ? JSON.stringify(x.PaymentResponse) : '',
              'Attempt (s)': AttemptSeconds !== undefined ? AttemptSeconds : '',
              'Diff (s)': DiffSeconds !== undefined ? DiffSeconds : '',
              'Gateway (s)': GatewaySeconds !== undefined ? GatewaySeconds : '',
              'Total (s)': TotalSeconds !== undefined ? TotalSeconds : ''
            };
          });
          TableUtil.exportArrayToExcel(exportData, 'PayoutOrders');
        } else {
          this.notifSer.info("Info", "No data available to export", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.notifSer.error("Error", "Failed to export data. Please try again.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.spinnerService.hide();
      }
    );
  }

  onUserSelectOpened(isOpen: boolean) {
    this.isUserSelectOpen = isOpen;
    if (isOpen) {
      // Reset filter when opening
      this.userSearchValue = '';
      this.filteredUserList = this.userList;
      // Wait for panel to render, then add search input
      setTimeout(() => {
        this.addSearchToSelectPanel();
      }, 150);
    } else {
      this.userSearchValue = '';
      this.filteredUserList = this.userList;
    }
  }

  addSearchToSelectPanel() {
    const panel = document.querySelector('.user-select-panel');
    if (panel) {
      // Remove existing search if any
      const existingSearch = panel.querySelector('.user-search-container');
      if (existingSearch) {
        existingSearch.remove();
      }

      const searchContainer = document.createElement('div');
      searchContainer.className = 'user-search-container';
      searchContainer.innerHTML = `
        <input 
          type="text" 
          placeholder="Search user..." 
          class="user-search-input"
          value="${this.userSearchValue || ''}">
      `;

      const searchInput = searchContainer.querySelector('.user-search-input') as HTMLInputElement;
      if (searchInput) {
        searchInput.addEventListener('input', (e: any) => {
          this.userSearchValue = e.target.value;
          this.filterUsers(e);
        });
        searchInput.addEventListener('click', (e: any) => {
          e.stopPropagation();
        });
        searchInput.addEventListener('keydown', (e: any) => {
          e.stopPropagation();
        });
      }

      // Insert search at the top of the panel
      if (panel.firstChild) {
        panel.insertBefore(searchContainer, panel.firstChild);
      } else {
        panel.appendChild(searchContainer);
      }

      // Focus the search input
      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 50);
      }
    }
  }

  filterUsers(event: any) {
    const searchTerm = event ? (event.target ? event.target.value : event) : this.userSearchValue;
    this.userSearchValue = searchTerm || '';

    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredUserList = this.userList;
      return;
    }

    const term = searchTerm.toLowerCase();
    this.filteredUserList = this.userList.filter(user => {
      const name = (user.name || '').toLowerCase();
      const email = (user.email || '').toLowerCase();
      return name.includes(term) || email.includes(term);
    });
  }

  // Removed onUserSelected - API will only be called on search button click

  public addNewRecord(): void {
    const newRecord = {};

    const dialogRef = this.dialog.open(AddEditPayoutOrderDialog, {
      width: '1400px',
      maxWidth: '95vw',
      data: { record: newRecord, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Payout order created successfully", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddEditPayoutOrderDialog, {
      width: '1400px',
      maxWidth: '95vw',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Payout order updated successfully", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.getData();
      }
    });
  }

  exportToS3() {
    this.spinnerService.show();

    // Use current filter settings
    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      paymentStatus: this.filter.paymentStatus,
      paymentGateway: this.filter.paymentGateway,
      userId: this.filter.userId || ''
    };

    this.userService.exportPayoutReport(exportFilter).subscribe(
      (response: any) => {
        this.spinnerService.hide();
        if (response && response.success) {
          this.notifSer.success("Success", response.message || "Report exported and uploaded to S3 successfully", {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 100,
          });
        } else {
          this.notifSer.error("Error", response.message || "Failed to export report", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      },
      (error) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", (error.error && error.error.message) || "Failed to export report. Please try again.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  showDownloadHistory() {
    // Open dialog first, then load data inside
    const dialogRef = this.dialog.open(PayoutReportHistoryDialogComponent, {
      width: '1000px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '90vh',
      data: {
        userService: this.userService,
        _csrf: this._csrf
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // Handle any post-dialog actions if needed
    });
  }

  // Unique errors per gateway for the applied filters (all pages, not just the loaded one)
  showErrorReport() {
    this.dialog.open(PayoutErrorReportDialogComponent, {
      width: '1000px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '90vh',
      data: {
        filter: {
          _csrf: this._csrf,
          fromDate: this.filter.fromDate,
          toDate: this.filter.toDate,
          paymentStatus: this.filter.paymentStatus,
          paymentGateway: this.filter.paymentGateway,
          userId: this.filter.userId || '',
          searchId: this.searchValue || ''
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-orders/payout-orders.component.ts